import { render, staticRenderFns } from "./RescueMain.vue?vue&type=template&id=5c2d30a5"
import script from "./RescueMain.vue?vue&type=script&lang=js"
export * from "./RescueMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports